import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ConvoModal from "./ConvoModal";
import { useTranslation } from "react-i18next";
var ActionErrorModal = function (_a) {
    var errorText = _a.errorText, isOpened = _a.isOpened, onClose = _a.onClose, _b = _a.error, error = _b === void 0 ? {} : _b;
    var t = useTranslation(["chat"]).t;
    return (_jsx(ConvoModal, { title: t(errorText.title), isModalOpen: isOpened, handleClose: onClose, modalBody: _jsx("div", { className: "modal-body", children: t(errorText.description) }), modalFooter: _jsx(_Fragment, { children: _jsx("button", { type: "button", className: "btn btn-secondary compact modal-cancel-button me-1", onClick: onClose, children: t("Cancel") }) }) }));
};
export default ActionErrorModal;
